import "../../styles/product-detail.css";
import Footer from "../../components/footer";
import Header from "../../components/header";
import dokmee from "../../images/dokmee.webp";

function Dokmee() {
  return (
    <div>
      <Header />
      <div className="product-details">
        <div className="details-heading">
          <h1>DOKMEE</h1>
        </div>
        <div className="dokmee-body">
          <div>
            <p>
              Dokmee is Electronic Document Management software (EDMS) suite
              that enables companies to adopt an electronic and automated
              approach to document management across the enterprise.
            </p>
            <p>
              It is a web based electronic document management system with a
              central repository for storing and organizing documents. It
              enables organizations to manage documents and records throughout
              the document life-cycle, from creation to destruction.
            </p>
            <p>
              Integrated collaboration and workflow tools can be used to access,
              create, modify, review, and approve documents globally in a
              controlled manner. It has a powerful analytics and reporting
              capability to track each document from origin to obsolescence to
              give users complete visibility into the system.
            </p>
          </div>
          <img className="dokmee-img" src={dokmee} alt="dokmee" />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Dokmee;
